<template src="./products.html">
</template>
<script>
import Accordion from './accordion.vue'
export default {
    components:{
        'accordion':Accordion
    },
    data() {
        return{
            items: [{
                id: 1,
                title: 'CABSOL Accounting and Financial Management Solution (AFMS)',
                content: [
                    'A comprehensive financial solution that supports charts of accounts,transactions, payroll and payment integration.',
                    'Line item or Ledger Accounts based budgeting with virement and integrated vote book to track commitment and variance',
                    'Customizable reporting for statutory and management purposes which includes Statement of Accounts, bank reconciliation, Ageing reports for Accounts Receivables/Payables for Vendor/Supplier, Client/Customer and Employees',
                    // 'Compute and retain depreciation figures for past, current and future periods',
                    ],
                isopen: false,
                link: "/contact-us"
            }, {
                id:2,
                title: 'CABSOL Fixed Assets Tracking and Management Solution (ATMS)',
                content: [
                    'Provide efficient financial assets evaluation management and effective auditing of all assets owned',
                    'Customized asset database to track, transfer and evaluate usage of owned assets in real-time',
                    'Create multiple asset depreciation schedules for an asset, with an option to create one for the books and another for taxes',
                    'Import Budget, Warrant and Cash Release data for use in determining newly procured assets',
                    ],
                isopen: false,
                link: "/contact-us"

            },
            {
                id:3,
                title: 'CABSOL Document Archiving and Retrieval Solution (DARS)',
                content: [
                    'Simplified document upload, archiving and retrieval processes',
                    'Managing organization wide project documents and official correspondences.',
                    'Customizable access rights and roles privileges for improved data security'
                    ],
                isopen: false,
                link: "/contact-us"
            },
            {
                id:4,
                title: 'CABSOL Inventory Management Solution (INMS)',
                content: [
                    'Customized inventory system for procurement, real-time tracking of products and stock keeping.',
                    'Provides an overview of items in stock, number of items expiring and the average distribution of items per period.',
                    'Customized reporting system based on predefined parameters.',
                    'Easy transfer of items from several locations with real time tracking features',
                    ],
                isopen: false,
                link: "/contact-us"
            },
            {
                id:5,
                title: 'CABSOL Payroll',
                content: [
                    'Ability to record employee specific information including start date & continuous service dates, job title, reporting lines, probationary periods and holiday entitlement.',
                    'Calculate FTE of an employee and pro-rate salary by FTE and integrates with third party payment gateways.',
                    'Creation of journal/accounts data for link to third party systems at user defined levels generation and maintenance',
                    "Apportionment of salaries of new and exiting employees are paid by user defined pro-rata pay profile",
                    ],
                isopen: false,
                link: "/contact-us"
            },
            ]
        }
    },   
}
</script>





// WEBPACK FOOTER //
// src/components/views/products/products.vue